export const EditWarehousePermission = Object.freeze({
    FOR_EMPLOYEE: 'FOR_EMPLOYEE',
    FOR_WAREHOUSE: 'FOR_WAREHOUSE'
})